import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, UsersIcon, UserIcon, AlertTriangleIcon } from 'lucide-react';
const CARDS = [{
  id: 'help',
  icon: ShieldCheckIcon,
  label: "I'm the one everyone calls for help",
  description: "You're the one making sure everyone's set up and protected."
}, {
  id: 'family',
  icon: UsersIcon,
  label: 'I want my family to be safer online',
  description: 'You want to get the important stuff done for your household.'
}, {
  id: 'solo',
  icon: UserIcon,
  label: "I'm managing my own security",
  description: 'You want to get your own setup locked down.'
}, {
  id: 'hacked',
  icon: AlertTriangleIcon,
  label: "I think I've been hacked or scammed",
  description: 'You need immediate help right now.'
}];
export function OnboardingGatePage() {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleContinue = () => {
    if (selectedId) {
      navigate('/quick-assessment');
    }
  };
  return <div className="min-h-screen bg-[#f8f8f8] flex flex-col items-center px-5 py-4 md:py-6" data-id="element-4579" data-mp="2483erpgmswuf">
      <div className="w-full max-w-md mx-auto flex flex-col flex-1" data-id="element-4580" data-mp="2iwpqlh71v6gw">
        {/* Logo */}
        <div className="flex justify-center mb-4" data-id="element-4581" data-mp="2e3oc3aar98xu">
          <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo" className="h-8 md:h-10 object-contain" data-id="element-4582" data-mp="2rvkyqytnmqmu" />
        </div>

        {/* Header Text */}
        <div className="text-center mb-4" data-id="element-4583" data-mp="31spp7auj989g">
          <h1 className="text-2xl md:text-3xl font-semibold text-[#1F0648] mb-2" data-id="element-4584" data-mp="31ro92ryntvkv">
            Let's figure out where to start.
          </h1>
          <p className="text-gray-500 text-base md:text-lg font-sans" data-id="element-4585" data-mp="17h15ywh9qjj9">
            Tell us your role so we can personalize your action plan.
          </p>
        </div>

        {/* Cards */}
        <div className="space-y-2.5 flex-1" data-id="element-4586" data-mp="1s5u0les3j2x3">
          {CARDS.map(card => {
          const isSelected = selectedId === card.id;
          const Icon = card.icon;
          return <motion.button key={card.id} onClick={() => setSelectedId(card.id)} whileTap={{
            scale: 0.98
          }} className={`w-full text-left p-4 rounded-xl border transition-all duration-200 flex items-start gap-4 min-h-[44px] ${isSelected ? 'border-[#1a0647] bg-[#f5f0ff]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-4587" data-mp="21577bzou5de4">
                <div className={`mt-1 shrink-0 ${isSelected ? 'text-[#1a0647]' : 'text-gray-400'}`} data-id="element-4588" data-mp="2jx03u4345gql">
                  <Icon size={24} data-id="element-4589" data-mp="2tue4ovcjzwxs" />
                </div>
                <div className="flex-1" data-id="element-4590" data-mp="2tvz3ix5wi21g">
                  <div className={`font-medium text-lg mb-1 leading-snug ${isSelected ? 'text-[#1a0647]' : 'text-[#111111]'}`} data-id="element-4591" data-mp="2ytiijzafaiug">
                    {card.label}
                  </div>
                  <div className={`text-sm font-sans leading-relaxed ${isSelected ? 'text-[#1a0647]/80' : 'text-gray-500'}`} data-id="element-4592" data-mp="i6suv1cade4x">
                    {card.description}
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        {/* Continue Button */}
        <div className="mt-4 pt-2 pb-4 sticky bottom-0 bg-[#f8f8f8]" data-id="element-4593" data-mp="15ypulu2gofpo">
          <button onClick={handleContinue} disabled={!selectedId} className={`w-full py-3.5 rounded-xl font-medium text-base transition-all duration-200 min-h-[44px] ${selectedId ? 'bg-[#1a0647] text-white hover:bg-[#2a0a6e] cursor-pointer' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-4594" data-mp="10yv2xoav3m3k">
            Continue
          </button>
        </div>
      </div>
    </div>;
}